import React from 'react'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { connect } from 'react-redux'
import { Checkbox } from 'react-bootstrap';
import { updateSubmission } from '../actions'
import { Loading } from '../../components/shared'
import client from '../../../apollo/client'
import gql from 'graphql-tag'
import { updateRelatedEntitiesWithEdgeNumber } from '../../utils/submission'

class LinkEdgeNumberModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            input: '',
            invalidNumber: false,
            saveSuccess: false,
            saveLoading: false,
            alreadyUsedNumber: false,
            doNotMapChecked: false,
            mapCheckLoader: false,
            submissionUnlinked: false,
            noSuchSubmission: false,
            mappedSubmission: {}
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
        this.updateEdgeNumber = this.updateEdgeNumber.bind(this)
    }

    componentDidUpdate(prevProps) {
        const { submission } = this.props
        let edgeInputNumber = ''
        let isUnmappable = false
        if (submission.relatedEntities && submission.relatedEntities.identifiers) {
            const identifiers = submission.relatedEntities.identifiers.filter((element) => element.type === 'edge')
            if (identifiers.length > 0) {
                if (identifiers[0].id != 'N/A') {
                    edgeInputNumber = identifiers[0].id
                } else {
                    isUnmappable = true
                }
            }
        }
        if (this.props.submission.id != prevProps.submission.id) {
            this.setState({invalidNumber: false, input: edgeInputNumber, saveSuccess: false, alreadyUsedNumber: false })
            if (isUnmappable) {
                this.setState({doNotMapChecked: true})
            }
        }
    }

    updateEdgeNumber(submission, edgeNumber) {
        const relatedEntities = updateRelatedEntitiesWithEdgeNumber(submission.relatedEntities, edgeNumber)
        this.props.updateSubmission(submission.id, { relatedEntities }, this.props.user, this.props.refetchSubmissions)
    }

    handleChange(event) {
        this.setState({ input: event.target.value.trim() })
    }

    async handleSave(event) {
        event.preventDefault()
        const edgeNumber = this.state.input
        this.setState({ saveLoading: true, saveSuccess: false, invalidNumber: false, alreadyUsedNumber: false, submissionUnlinked: false, noSuchSubmission: false })
        if (this.isEdgeNumberValid(edgeNumber)) {
            let { submission, user } = this.props
            if (!edgeNumber.length) {
                // Clear the edge number linking
                this.updateEdgeNumber(submission, edgeNumber)
                this.setState({ submissionUnlinked: true, saveLoading: false, noSuchSubmission: false })
            } else {
                // Check if edge number already exists
                const { data: { submissionForEdgeNumber }} = await this.getSubmissionForEdgeNumber(edgeNumber)
                if (!!submissionForEdgeNumber && !submissionForEdgeNumber.id) {
                    this.updateEdgeNumber(submission, edgeNumber)
                    this.setState({ saveSuccess: true, saveLoading: false, noSuchSubmission: false })
                } else if (!!submissionForEdgeNumber) {
                    // Request to get submission details
                    const { data: { getSubmission: mappedSubmission }} = await this.getSubmissionById(submissionForEdgeNumber.id)
                    this.setState({
                        alreadyUsedNumber: true,
                        saveLoading: false,
                        mappedSubmission: {
                            primaryInsuredName: mappedSubmission.primaryInsuredName,
                            agencyName: mappedSubmission.brokerage.name,
                            createdAt: moment(mappedSubmission.createdAt).format('D/MM/YYYY')
                        }
                    })
                } else {
                    this.setState({noSuchSubmission: true, saveSuccess: false, saveLoading: false })
                }
            }
        } else {
            this.setState({invalidNumber: true, saveSuccess: false, saveLoading: false, noSuchSubmission: false })
        }
    }

    isEdgeNumberValid(number) {
        return ((number.length === 12 || number.length === 0) && /^[0-9]*$/.test(number))
    }

    async getSubmissionForEdgeNumber(number) {
        return client.query({
            fetchPolicy: 'no-cache',
            variables: {
                edgeNumber: number
            },
            query: gql`
                query submissionForEdgeNumber($edgeNumber: String) {
                    submissionForEdgeNumber(edgeNumber: $edgeNumber) { id }
                }`
        })
    }

    async getSubmissionById(id) {
        return client.query({
            variables: {
                id
            },
            query: gql`
                query getSubmission($id: ID!) {
                    getSubmission(id: $id) { primaryInsuredName brokerage { name } createdAt }
                }`
        })
    }

    async handleCheckboxChange(event) {
        let { submission, user } = this.props
        this.setState({mapCheckLoader: true, invalidNumber: false, alreadyUsedNumber: false, saveSuccess: false, input: '', submissionUnlinked: false})
        if (event.target.checked) {
            this.setState({doNotMapChecked: true})
            this.updateEdgeNumber(submission, 'N/A')
            this.setState({submissionUnlinked: true})
        } else {
            this.setState({doNotMapChecked: false})
            this.updateEdgeNumber(submission, '')
        }
        this.setState({mapCheckLoader: false})
    }

    render() {
        const { submission, broker } = this.props
        const product = submission.type === 'oi' ? "Owner's Interest" : 'Owners and Contractors Protective'
        return (
            <div>
                {isEmpty(submission) &&
                    <div className="modal-loader">
                        <Loading width="44px" height="44px" />
                    </div>
                }
                {!isEmpty(submission) &&
                <div className="modal-main">
                    <div className="modal-details">
                        <div className="details-heading">
                            <label>Owner&apos;s Edge: {product} Submission</label>
                        </div>
                        <div className="row details-content">
                            <div className="col-xs-12 col-md-6">
                                <address>
                                    <small className="text-muted">First Name Insured</small>
                                    <br />
                                    {submission.primaryInsuredName}
                                    <br />
                                    {submission.insuredAddress.primaryInsuredAddress} <br />
                                    {submission.insuredAddress.insuredAddress}{' '}
                                    {submission.insuredAddress.primaryInsuredState}{' '}
                                    {submission.insuredAddress.primaryInsuredZipcode}
                                    <br />
                                </address>
                                <address>
                                    <small className="text-muted">Project Address</small>
                                    <br />
                                    {submission.projectAddress.projectAddress}
                                    <br />
                                    {submission.projectAddress.projectCity} {submission.projectAddress.projectState}{' '}
                                    {submission.projectAddress.projectZipcode}
                                    <br />
                                </address>
                            </div>
                            <div className="col-xs-12 col-md-6 card-box">
                                <small className="text-muted">Broker</small>
                                <p>
                                    {submission.contactInfo.email} <br />
                                </p>

                                <small className="text-muted">Agency</small>
                                <p>
                                    {broker.name}
                                </p>
                                <small>
                                    <p className="text-muted">
                                        {moment(submission.createdAt).format('D/MM/YYYY')}{' '} submitted <br />
                                    </p>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <form>
                                EDGE Submission Number
                                <input type="text" className="text-input" onChange={this.handleChange} value={this.state.input} disabled={this.state.doNotMapChecked} />
                                <button className="btn-default btn save-button" onClick={this.handleSave} disabled={this.state.saveLoading || this.state.doNotMapChecked}>Save Changes</button>
                            </form>
                        </div>
                        {this.state.alreadyUsedNumber &&
                            <div className="col-xs-12 col-md-6">
                                <small className="text-muted">EDGE Number already linked to another submission:</small>
                                <br />
                                <p>
                                    <strong>{this.state.mappedSubmission.primaryInsuredName}</strong> <br />
                                    {this.state.mappedSubmission.agencyName} <br />
                                    {this.state.mappedSubmission.createdAt} <br />
                                </p>
                            </div>
                        }
                    </div>
                    <div className="notification-text">
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                            {this.state.invalidNumber &&
                                <div className="warning-text">
                                    Submission number requires 12 characters
                                </div>
                            }
                            {this.state.saveSuccess &&
                                <div className="success-text">
                                    Submission linked to EDGE
                                </div>
                            }
                            {this.state.submissionUnlinked &&
                                <div className="success-text">
                                    Submission is unlinked from EDGE
                                </div>
                            }
                            {this.state.alreadyUsedNumber &&
                                <div className="error-text">
                                    Number already linked to another submission
                                </div>
                            }
                            {this.state.saveLoading &&
                                <div>
                                    <Loading width="22px" height="22px" />
                                </div>
                            }
                            {this.state.noSuchSubmission &&
                                <div className="error-text">
                                    The entered Edge submission number does not exist
                                </div>
                            }
                        </div>
                    </div>
                    </div>
                    <div>
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                                <button className="btn-link close-button" onClick={this.props.onHide}>Close and return to submissions</button>
                            </div>
                            <div className="col-xs-12 col-md-3">
                                {this.state.mapCheckLoader &&
                                    <div className="map-check-loader">
                                        <Loading width="15px" height="15px" />
                                    </div>
                                }
                            </div>
                            <div className="col-xs-12 col-md-3">
                                <Checkbox inline onClick={this.handleCheckboxChange} id="map-checkbox" checked={this.state.doNotMapChecked}>Do not map</Checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        )

    }
}

const mapStateToProps = state => ({
    user: state.user,
    person: state.person
  })

export default connect(mapStateToProps, { updateSubmission })(LinkEdgeNumberModal)